import styled from "styled-components";
import {
  device,
  colors,
  getTypographyFontStyle,
} from "../../styles/global.style";

export const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 100px 20px 60px;

  @media ${device.md} {
    padding: 140px 32px 80px;
  }

  @media ${device.lg} {
    padding: 160px 48px 100px;
  }
`;

export const HeaderSection = styled.div`
  text-align: center;
  margin-bottom: 48px;
  padding-bottom: 32px;
  border-bottom: 1px solid ${colors.border};

  @media ${device.md} {
    margin-bottom: 64px;
    padding-bottom: 40px;
  }
`;

export const Title = styled.h1`
  ${getTypographyFontStyle({ variant: "h1", weight: 700 })};
  color: ${colors.secondary};
  margin-bottom: 12px;

  @media ${device.md} {
    margin-bottom: 16px;
  }
`;

export const LastUpdated = styled.p`
  ${getTypographyFontStyle({ variant: "body2", weight: 400 })};
  color: ${colors.darkGrey};
  font-style: italic;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media ${device.md} {
    gap: 40px;
  }
`;

export const Section = styled.section`
  scroll-margin-top: 100px;
`;

export const SectionTitle = styled.h2`
  ${getTypographyFontStyle({ variant: "h3", weight: 600 })};
  color: ${colors.secondary};
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid ${colors.primaryBg};
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 60px;
    height: 2px;
    background: ${colors.solarGradient};
  }

  @media ${device.md} {
    margin-bottom: 20px;
  }
`;

export const SectionContent = styled.p`
  ${getTypographyFontStyle({ variant: "body1", weight: 400 })};
  color: ${colors.lightdark};
  line-height: 1.8;
  margin-bottom: 16px;

  @media ${device.md} {
    line-height: 1.9;
  }
`;

export const List = styled.ul`
  margin: 0 0 0 20px;
  padding: 0;
`;

export const ListItem = styled.li`
  ${getTypographyFontStyle({ variant: "body1", weight: 400 })};
  color: ${colors.lightdark};
  line-height: 1.8;
  margin-bottom: 12px;
  padding-left: 8px;

  &::marker {
    color: ${colors.primary};
  }

  strong {
    color: ${colors.secondary};
    font-weight: 600;
  }

  @media ${device.md} {
    line-height: 1.9;
  }
`;

export const ContactBox = styled.div`
  background: ${colors.primaryBg};
  border-radius: 16px;
  padding: 24px;
  margin-top: 16px;

  p {
    margin: 0 0 12px;
    ${getTypographyFontStyle({ variant: "body1", weight: 400 })};
    color: ${colors.lightdark};
    line-height: 1.6;

    &:last-of-type {
      margin-bottom: 16px;
    }
  }

  @media ${device.md} {
    padding: 32px;
  }
`;

export const ContactLink = styled.a`
  display: block;
  ${getTypographyFontStyle({ variant: "body1", weight: 500 })};
  color: ${colors.primary};
  text-decoration: none;
  margin-bottom: 8px;
  transition: color 0.3s ease;

  &:hover {
    color: ${colors.primaryDark};
    text-decoration: underline;
  }
`;
